import { LockClosedIcon, LockOpenIcon } from '@repo/ui/icons'
import Lock from '@repo/ui/lock'
import Modal from '@repo/ui/modal'
import { useMutation } from '@tanstack/react-query'
import React, { useState } from 'react'
import { toast } from 'sonner'

import { lockCenter, unlockCenter } from '../../../api/centers/update-center'
import { showAxiosError } from '../../../lib/utils/functions/misc.functions'

type Props = {
  centerId: number
  centerName: string
  centerLocked: boolean
}

const CenterLock: React.FC<Props> = ({ centerId, centerName, centerLocked }) => {
  const [locked, setLocked] = useState(centerLocked)
  const [isConfirmOpen, setIsConfirmOpen] = useState(false)

  const { mutate: lockCenterMutation, isPending: isLockPending } = useMutation({
    mutationFn: lockCenter,
    onError: showAxiosError,
    onSuccess: () => {
      setLocked(true)
      setIsConfirmOpen(false)
      toast.success('Centre verrouillé')
    }
  })

  const { mutate: unlockCenterMutation, isPending: isUnlockPending } = useMutation({
    mutationFn: unlockCenter,
    onError: showAxiosError,
    onSuccess: () => {
      setLocked(false)
      setIsConfirmOpen(false)
      toast.success('Centre déverrouillé')
    }
  })

  return (
    <>
      <Lock
        isLocked={locked}
        onClick={(e) => {
          e.stopPropagation()
          setIsConfirmOpen(true)
        }}
      />
      {/* stop clicks inside the modal from reaching the table row (row click opens the centre) */}
      <div className="contents" onClick={(e) => e.stopPropagation()}>
        <Modal
          isOpen={isConfirmOpen}
          variant="confirmation"
          icon={locked ? LockOpenIcon : LockClosedIcon}
          title={`Êtes-vous sûr de vouloir ${locked ? 'déverrouiller' : 'verrouiller'} les centres suivants : ${centerName} ?`}
          isLoading={isLockPending || isUnlockPending}
          actionButtonsOptions={{
            confirmText: 'Oui',
            cancelText: 'Retour',
            onConfirm: () => {
              if (locked) unlockCenterMutation(centerId)
              else lockCenterMutation(centerId)
            }
          }}
          onCancel={() => setIsConfirmOpen(false)}
        />
      </div>
    </>
  )
}

export default CenterLock
